import { MakeAndModelController } from "./control.controller.make-model"
import { BudgetSliderController } from "./control.controller.budget-slider"
import { uniqueModels } from "./utils"

/**
 * Entry point form controller.
 * 
 * @since 1.0.0
 * @package dealerkit-wp
 */
export class SearchEntryPointController
{
    constructor(core, $container, id, priceSearchDefault, type) {
        this.core = core

        this.$container = $container

        this.id = id

        this.type = type

        this.priceSearchDefault = priceSearchDefault

        this.setButtonElementReferences()
    }

    render() {
        if (!this.type || this.type === 'default') {
            const $controlContainer = this.$container.querySelector('#makeAndModel_' + this.id);

            this.controls = new MakeAndModelController(this.core, $controlContainer)

            this.controls.hideCounts()

            this.controls.change((make, model, budgetType, budget) => {
                this.controls.disable()

                this.search(make, model, budgetType, budget)
            })
        } else if (this.type === 'budget-slider') {
            this.controls = new BudgetSliderController(this.core, this.$container)

            this.controls.change(budget => {
                this.controls.disable()

                this.search('', '', this.priceSearchDefault, budget)
            })
        }

        this.search()
    }

    setButtonElementReferences() {
        this.buttonText = this.$container.querySelector('.search-entry-point-model-button-text')
        this.buttonLoader = this.$container.querySelector('.search-entry-point-model-button-loading')
        this.buttonCount = this.$container.querySelector('.search-entry-point-num-vehicles')
    }

    search(make = '', model = '', priceSearchType = '', budget = '') {

        // Disable the controls.
        this.controls.disable()

        // Setup the search parameters.
        let params = {}

        if (make.length > 0) {
            params.make = make
        }

        if (make.length > 0 && model.length > 0) {
            params.model = model
        }

        if (budget.length > 0) {
            params.price_to = budget
            params.price_search_type = priceSearchType
        }

        this.buttonText.style.display = 'none';
        this.buttonLoader.style.display = 'inline';

        const urlParams = new URLSearchParams(params)

        // Set the button variables.
        let url = new URL(this.buttonText.parentNode.getAttribute('href'))
        url.searchParams.delete('make')
        url.searchParams.delete('model')
        url.searchParams.delete('price_to')
        url.searchParams.delete('price_search_type')

        if (urlParams.has('make')) {
            url.searchParams.append('make', urlParams.get('make'))

            if (urlParams.has('model')) {
                url.searchParams.append('model', urlParams.get('model'))
            }
        }

        priceSearchType = this.priceSearchDefault
        if (urlParams.has('price_to') && urlParams.has('price_search_type')) {
            url.searchParams.append('price_to', urlParams.get('price_to'))
            priceSearchType = urlParams.get('price_search_type')
            url.searchParams.append('price_search_type', priceSearchType)
        }

        this.buttonText.parentNode.setAttribute('href', url)

        // Request the data.
        fetch(DEALERKIT_WP_ENDPOINT + "/search-entry-point?" + urlParams).then(r => {
            r.json().then(json => {
                // Set the button count & enable the button
                this.buttonCount.innerHTML = json.searchFacets.total_results

                this.buttonLoader.style.display = 'none';

                this.buttonText.style.display = 'inline'
                
                this.controls.render(
                    json.searchFacets.facets.manufacturers,
                    uniqueModels(json.searchFacets.facets.models),
                    priceSearchType,
                    { 
                        'full': json.globalFacets.facets.advertising_price,
                        'monthly': json.globalFacets.facets.monthly_price,
                    },
                    params
                )
            })
        })
    }
}